import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import type { NetworkLayout } from '../state/useNetworkLayout'

interface LayoutOption {
  value: NetworkLayout
  disabled: boolean
}

const LAYOUT_OPTIONS: LayoutOption[] = [
  { value: '2d', disabled: false },
  { value: '3d', disabled: false },
  { value: 'classic', disabled: true },
  { value: 'artistic', disabled: true },
]

interface NetworkLayoutPickerProps {
  layout: NetworkLayout
  onChange: (next: NetworkLayout) => void
}

export function NetworkLayoutPicker({ layout, onChange }: NetworkLayoutPickerProps) {
  const { t } = useTranslation('network')

  return (
    <div className="flex items-center gap-1 rounded-full bg-secondary/30 p-0.5 ring-1 ring-primary/15">
      {LAYOUT_OPTIONS.map((opt) => (
        <button
          key={opt.value}
          type="button"
          disabled={opt.disabled}
          onClick={() => !opt.disabled && onChange(opt.value)}
          className={cn(
            'relative min-h-[36px] rounded-full px-3 py-1.5 text-xs font-semibold transition-all active:scale-95 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:outline-none',
            layout === opt.value && !opt.disabled
              ? 'bg-card text-foreground shadow-sm'
              : 'text-muted-foreground hover:text-foreground',
            opt.disabled && 'cursor-not-allowed opacity-40 hover:text-muted-foreground',
          )}
          aria-pressed={layout === opt.value && !opt.disabled}
          aria-disabled={opt.disabled}
          title={opt.disabled ? t('layout.comingSoon') : undefined}
        >
          {t(`layout.${opt.value}`)}
          {opt.disabled && (
            <span className="ml-1.5 inline-flex items-center rounded-full bg-secondary px-1 py-0 text-[9px] font-medium text-muted-foreground">
              {t('layout.comingSoon')}
            </span>
          )}
        </button>
      ))}
    </div>
  )
}
